<div>
    <app-car-box-list
        [businessLine]= businessLine!>

    </app-car-box-list>
</div>
